<div class="ui-proveedores-consulta-registro">
  <div class="ui-proveedores-consulta-registro__header">
    <ui-app-header
      variant="consultation"
      [logoSrc]="logoSrc()"
      [logoAlt]="logoAlt()"
      [navTitle]="navTitle()"
      [showMenuToggle]="false"
      [userAvatarLabel]="userAvatarLabel()"
      [userAvatarAlt]="userAvatarAlt()"
      [profileUserName]="profileUserName()"
      [profileUserRole]="profileUserRole()"
      [profileUserEmail]="profileUserEmail()"
      (notificationClick)="notificationClick.emit()"
      (logoutClick)="logoutClick.emit()"
    />
  </div>

  <main class="ui-proveedores-consulta-registro__main">
    <ui-step-validation
      [steps]="steps()"
      [interactive]="interactive()"
      [selectedId]="selectedId()"
      [showStatusCount]="false"
      ariaLabel="Estatus del registro"
      (stepSelect)="stepSelect.emit($event)"
    />
    <ng-content />
  </main>
</div>
